import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { ProjectService } from 'src/app/_services/project.service';
import { ReportService } from 'src/app/_services/report.service';
import { TestService } from 'src/app/_services/test.service';
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver';
import * as fileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment-timezone';
import { ExcelService } from 'src/app/_services/excel.service';
import { ChartColor, ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { Chart } from '../latest-report/chart';

@Component({
  selector: 'app-suite-report',
  templateUrl: './suite-report.component.html',
  styleUrls: ['./suite-report.component.scss']
})
export class SuiteReportComponent implements OnInit {

  projectId: any;
  projectReportData: any;
  projectData: any;
  projectName: any;
  toDate =  Math.floor(new Date(new Date()).getTime());
  fromDate= (Math.floor(new Date(new Date()).getTime()) - (60 * 24 * 60 * 60 * 1000));
  status = ['ALL','PASS','FAIL','INCONCLUSIVE','SKIPPED','BLOCKED','NOT RUN'];
  suitFileData: any;
  suit = ['ALL'];
  suiteValue = 'ALL';
  statusV = 'ALL';
  suiteId: any;
  enableSuite: boolean;
  indexFormArray: UntypedFormArray;
  form:UntypedFormGroup;
  getSuitReportData: any;
  url: string;
  enableMergereport: boolean = false;
  item: {};
  jsonToBeUsedForList: any;

  reportDataForExcel: any;
  myArray: any;
  myFilter: any;
  myArrayFiltered: any;
  title: string;
  reportName: string;
  browser='ALL';
  suiteReportData: Object;
  passCount: number;
  failCount: number;
  inCount: number;
  notRunCount: number;
  blockedCount: number;
  skippedCount: number;

  public barChartColors: ChartColor[] = [
    'rgb(92, 184, 92)',
    'rgb(217, 83, 79)',
    'rgb(236, 59, 15)',
    'rgb(240, 173, 78)',
     'rgb(91, 192, 222)', 
     'rgb(102, 205, 170)'
  ]
  public barChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'right',
    }
  };
  charData: any=[];
  public barChartLabels: Label[];
  public barChartType: ChartType = 'pie';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartData: ChartDataSets[]=[];
  public pieColor: ChartColor[]=[];
  chartList: Array<Chart> = [];
  blinkArry: any[]=[];
  numarray: Array<Number>=[];

  constructor(
    private report: ReportService,
    private project: ProjectService,
    private testService: TestService,
    private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private route: ActivatedRoute,
  private toastrService:ToastrService,
  private confirmationDialogService:ConfirmationDialogService,
  private excelService:ExcelService,
  @Inject( DOCUMENT ) private document: Document,
  ) {
    this.url = environment.baseUrl
    this.form = this.formBuilder.group({
      checkArray: this.formBuilder.array([])
    })
   }

  ngOnInit() {
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.suiteId = params.get('suiteId');
       this.project.getProjectById(this.projectId).subscribe(
         (data)=>{
           this.projectData = data;
           this.projectName = this.projectData.projectName;
         }
       )
       //console.log('from>',this.fromDate);
       //console.log('to>',this.toDate);
      //  this.getCurrentDate();
      
        this.getSuiteData(this.projectId,this.suiteId);
        this.getHistoryData(this.projectId,this.fromDate,this.toDate,this.browser)
      }
    )
}

getSuiteData(projectId,suiteId){
  this.report.getTestSuiteReport(projectId,suiteId).subscribe(
    (data)=>{
      this.suiteReportData = data;
      //console.log(data);
    }
  )
}
selectChartType(chartType){
  this.barChartType = chartType;
}
getHistoryData(projectId,fromDate,toDate,browser){
  this.report.getHistoryReport(projectId,fromDate,toDate,browser).subscribe(
    (data)=>{
      //console.log(data);
      this.getSuitReportData = data['historyReport'];
      // var testSuiteSummary = $scope.convertArray($scope.suiteReportData.runningSuites)[i];
if(this.getSuitReportData){
  this.passCount = Number(this.getRunningSuiteData(this.getSuitReportData[0].runningSuites[0], 3));
  this.failCount = Number(this.getRunningSuiteData(this.getSuitReportData[0].runningSuites[0], 4));
  this.inCount = Number(this.getRunningSuiteData(this.getSuitReportData[0].runningSuites[0], 6));
  this.notRunCount = Number(0);
  this.blockedCount = Number(this.getRunningSuiteData(this.getSuitReportData[0].runningSuites[0], 5));
  this.skippedCount = Number(this.getRunningSuiteData(this.getSuitReportData[0].runningSuites[0], 7));

  // var projectSummary = this.getSuitReportData;
  let chartObj = new Chart();
  chartObj.pass = this.passCount
  chartObj.fail = this.failCount
  chartObj.blocked = this.blockedCount
  chartObj.inconclusive = this.inCount
  chartObj.notRun = this.notRunCount
  chartObj.skipped = this.skippedCount
  this.chartList.push(chartObj);
this.barChartLabels = ['Pass','Fail','Blocked','Inconclusive','Not Run','Skipped']
for(let c of this.chartList){
  this.blinkArry.push(Object.values(c));
}
this.numarray = JSON.parse(JSON.stringify(this.blinkArry[0]));
const toNumbers = arr => arr.map(Number);
 var n = toNumbers(this.numarray);
this.barChartData = [{ data:  n,label: 'Bar Chart' ,backgroundColor: this.barChartColors,hoverBackgroundColor: this.barChartColors,hoverBorderColor: this.barChartColors}];
}
else{
  this.toastrService.clear();
  this.toastrService.info('No last report Found');
}  
    }
  );
}
getRunningSuiteData(data, index) {
  if (data) {
      return data.split("|")[index];
  }
  return "";
}
}
